const local = {
  name: "local",
  API_BASE_URL: "http://localhost:8000",
};

const staging = {
  name: "staging",
  API_BASE_URL: "https://liwat-id-backend.herokuapp.com",
};

const production = {
  name: "production",
  API_BASE_URL: "https://liwat-backend.herokuapp.com",
};

const ENV = {
  local,
  development: staging,
  staging,
  production,
  test: local,
};

export const ACTIVE_ENV =
  ENV[process.env.REACT_APP_ENV || "staging"] || ENV["staging"];

export default ACTIVE_ENV;
